<sn-player
  #player
  [caption]="caption"
  [elevation]="elevation"
  [width]="width"
  [height]="height"
  [aspectRatio]="aspectRatio"
  [state]="state$ | async"
>
  <div
    snPlayerContent
    class="sn-image-player__content"
    [ngClass]="{ 'sn-image-player__content__hasOverlay': hasOverlay }"
  >
    <ng-content select="[fsPlayerImage]"></ng-content>
    <img [@snFadeIn] [@snFadeOut] [src]="frameSrc" *ngIf="frameSrc" />
    <div class="sn-image-player__loader" *ngIf="isLoading">
      <mat-spinner [diameter]="48" [strokeWidth]="4" color="accent"></mat-spinner>
    </div>
  </div>

  <div snPlayerFooter class="sn-image-player__footer" *ngIf="controls">
    <sn-icon-button matTooltip="Screenshot Video" (click)="clip()">
      <sn-icon>content_cut</sn-icon>
    </sn-icon-button>
    <sn-player-footer-section alignment="end">
      <sn-player-fullscreen-control></sn-player-fullscreen-control>
    </sn-player-footer-section>
    <ng-content select="[fsPlayerFooter]"></ng-content>
  </div>
</sn-player>
